// extracted by mini-css-extract-plugin
export default {"overlay":"OpenPack_overlay__ubROF","openingPackMobile":"OpenPack_openingPackMobile__hYXHW","openingPackDesktop":"OpenPack_openingPackDesktop__ej8sL","pack":"OpenPack_pack__V7kVf"};